import React, { useCallback, useEffect, useState } from 'react';
import { StudentRetaketationWrapper } from './styled';
import images from 'assets/sheets/images';
import { Divider, Spin } from 'antd';
import Button from 'components/Button';
import ChooseMonthDate from 'components/ChooseDate/ChooseMonthDate';
import Select from 'components/Select';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import CourseServices from 'services/CourseServices';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';
import Input from 'components/Input/Input';
import CustomTable from 'components/CustomTable/CustomTable';
import Pagination from 'components/Pagination';
import {
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  TIME_ZONE,
} from 'helper/init.constants';
import NotePopup from './components/NotePopup';
import InfoUserPopup from './components/InfoUserPopup';
import AddMemberPopup from './components/AddMemberPopup';
import { clearAllFields } from 'pages/CourseSchedule';
import dayjs from 'dayjs';
import PopupConfirm from './components/PopupConfirm';
import { checkStatusTransition } from './rules';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const initiaState = {
  search: '',
  courseId: 'ALL',
  courseScheduleId: 'ALL',
  startTime: '',
  endTime: '',
  page: DEFAULT_PAGE_NUMBER,
  pageSize: DEFAULT_PAGE_SIZE,
};

const statusOptions = [
  {
    label: '受付済み',
    value: 'PAYMENT_COMPLETED',
    color: '#1890FF',
    bgColor: '#E6F7FF',
  },
  {
    label: 'キャンセル待ち',
    value: 'CANCELLATION_WAITING_LIST',
    color: '#00805A',
    bgColor: '#EBFFEE',
  },
  {
    label: 'キャンセル',
    value: 'ADMIN_CANCELED',
    color: '#FA8C16',
    bgColor: '#FFF7E6',
  },
];

const RetakeStudentManagement = () => {
  const [loading, setLoading] = useState(false);
  const [courseId, setCourseId] = useState(null);
  const [form, setForm] = useState(initiaState);
  const [addMember, setAddMember] = useState(null);
  const [infoId, setInfoId] = useState(null);
  const [noteId, setNoteId] = useState(null);
  const [course, setCourse] = useState([]);
  const [listCourseRegistration, setListCourseRegistration] = useState(null);
  const [changeStatusConfirm, setChangeStatusConfirm] = useState({
    courseId: null,
    status: null,
    day: null,
    message: null,
  });

  const makeAttendanceColumn = (dayNum) => ({
    title: `受講日(${dayNum + 1}日目)`,
    dataIndex: `day_attendance_${dayNum}`,
    key: `day_attendance_${dayNum}`,
    width: 160,
    render: (_, record) => {
      const daySchedule = record.schedule.find((s) => s.day === dayNum + 1);
      const currentStatus = daySchedule?.status || '';

      const getStatusStyle = () => {
        const option = statusOptions.find((item) => item.value === currentStatus);
        if (!option) return '';

        const colorMap = {
          PAYMENT_COMPLETED: '!text-[#1890FF] !bg-[#E6F7FF] !border-none',
          CANCELLATION_WAITING_LIST: '!text-[#00805A] !bg-[#EBFFEE] !border-none',
          ADMIN_CANCELED: '!text-[#FA8C16] !bg-[#FFF7E6] !border-none',
        };

        return colorMap[option.value] || '';
      };

      const handleStatusChange = ({ value }) => {
        if (currentStatus === '') {
          setChangeStatusConfirm({
            courseId: record._id,
            day: dayNum + 1,
            status: value,
            message:
              'ステータスを［' +
              statusOptions.find((item) => item.value === value).label +
              '］に変更します。',
          });
          return;
        }
        const isResult = checkStatusTransition(currentStatus, value, record.paymentMethod);

        !isResult?.allow &&
          isResult.error &&
          toast.error(
            <div style={{ whiteSpace: 'pre-wrap', fontWeight: 500 }}>{isResult?.error}</div>,
          );

        isResult?.allow &&
          setChangeStatusConfirm({
            courseId: record._id,
            day: dayNum + 1,
            status: value,
            message: isResult.message,
          });
      };

      if (record.schedule.some((s) => s.day === dayNum + 1)) {
        return (
          <Select
            value={currentStatus}
            onChange={(e) => handleStatusChange({ value: e.value })}
            heightSelect={28}
            rounded={4}
            classNameLabel={getStatusStyle()}
            className={`h-7 max-w-[145px] !rounded-[4px] ${getStatusStyle()} [&_.ant-select-selection-item]:flex [&_.ant-select-selection-item]:w-full [&_.ant-select-selection-item]:items-center [&_.ant-select-selection-item]:justify-between [&_.ant-select-selection-item]:text-inherit`}
            popupClassName="[&_.ant-select-item-option-selected]:bg-transparent [&_.ant-select-item-option-active]:bg-[#E6F7FF] [&_.ant-select-item]:text-inherit"
            suffixIcon={
              <div className="pointer-events-none ml-1">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-current"
                >
                  <path
                    d="M2 4.5L6 8.5L10 4.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            }
            classNameSelect={`!h-7 !min-w-[130px] !rounded-[4px] px-2 flex items-center justify-between ${getStatusStyle()}`}
            classNameValue="!text-inherit"
            isShowCurrent={true}
            options={statusOptions}
          />
        );
      }

      return null;
    },
  });

  const attendanceColumns = Array.from({ length: 8 }, (_, i) => makeAttendanceColumn(i));

  const columns = [
    {
      title: '開催ID',
      dataIndex: 'id',
      fixed: 'left',
      key: 'receptionNumber',
      width: 127,
      render: (_, record) => {
        return <div>{record.courseSchedules.eventId}</div>;
      },
    },
    {
      title: '開催1日目',
      dataIndex: 'eventDate',
      fixed: 'left',
      key: 'eventDate',
      width: 133,
      render: (_, record) => {
        return (
          <div>
            {record.courseSchedules.schedule?.[0]?.startTime &&
              dayjs(record?.courseSchedules?.schedule?.[0]?.startTime).format('YYYY/MM/DD')}
          </div>
        );
      },
    },
    {
      title: '名前',
      dataIndex: 'name',
      fixed: 'left',
      key: 'name',
      width: 133,
      render: (_, record) => {
        return <div>{record?.users?.name}</div>;
      },
    },
    {
      title: 'メールアドレス',
      dataIndex: 'email',
      key: 'email',
      width: 250,
      render: (_, record) => {
        return <div>{record?.users?.email}</div>;
      },
    },
    {
      title: '電話番号',
      dataIndex: 'phone',
      key: 'phone',
      width: 135,
      render: (_, record) => {
        return <div>{record?.users?.phone}</div>;
      },
    },
    {
      title: '領収書宛名',
      dataIndex: 'receiptName',
      key: 'receiptName',
      width: 151,
      render: (_, record) => {
        if (record?.receiptRecipient !== 'REQUEST') return null;
        return <div>{record?.receiptAddressee || record?.users?.name}</div>;
      },
    },
    {
      title: '申込日',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 110,
      render: (_, record) => {
        return <div>{dayjs(record?.createdAt).format('YYYY/MM/DD')}</div>;
      },
    },
    ...attendanceColumns,
    {
      title: '備考',
      dataIndex: 'notes',
      key: 'notes',
      width: 245,
      render: (_, record) => {
        return (
          <div
            className="max-w-[230px]"
            title={record?.notes}
            style={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{ __html: htmlToFormattedText(record?.notes) }}
          />
        );
      },
    },
    {
      title: 'アクション',
      dataIndex: 'action',
      key: 'action',
      width: 163,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <div
            onClick={() => handleOpenPopupNote(record)}
            className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
          >
            <images.taskEdit.src />
          </div>
          <div
            onClick={() => setInfoId(record?._id)}
            className="flex h-[36px] w-[36px] items-center justify-center rounded-[8px] border border-[#E6EBF1] bg-white hover:cursor-pointer"
          >
            <images.eyeStudent.src />
          </div>
        </div>
      ),
    },
  ];

  const handleOpenPopupNote = (record) => {
    setNoteId(record?._id);
  };

  const handleChangePage = (page, pageSize) => {
    const now = dayjs();
    const body = clearAllFields({
      ...form,
      type: 'RETAKE',
      startTime: form.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
      page,
      pageSize,
    });

    setForm(body);
    getStudentRetaketation(body);
  };

  const getCourseRegistrationById = () => {
    setLoading(true);
    CourseScheduleRegistationServices.getCourseRegistrationById()
      .then((res) => {
        setCourseId(
          res?.data?.items.map((item) => ({
            value: item._id,
            label: item.eventId,
          })),
        );
      })
      .catch(() => toast.error(NO_INTERNET))
      .finally(() => setLoading(false));
  };

  const getCourses = () =>
    CourseServices.getCourses({})
      .then((res) =>
        setCourse(
          res.data
            .map((item) => ({
              value: item._id,
              label: item.name,
            }))
            .map((i) =>
              i.label === 'インテグレーティッドトレーニング'
                ? {
                    value: i.value,
                    label: 'インテグレーティッド',
                  }
                : i,
            ),
        ),
      )
      .catch((err) => toast.error(err.message || NO_INTERNET));

  useEffect(() => {
    const now = dayjs();
    getStudentRetaketation(
      clearAllFields({
        ...form,
        page: form.page || DEFAULT_PAGE_NUMBER,
        pageSize: form.pageSize || DEFAULT_PAGE_SIZE,
        startTime: now.subtract(1, 'year').format('YYYY-MM-DD'),
        type: 'RETAKE',
      }),
    );
    getCourseRegistrationById();
    getCourses();
  }, []);

  const handleChangeData = ({ label, value }) => {
    setForm({
      ...form,
      [label]: value,
    });
  };

  const handleDateChange = (dates) => {
    if (!dates || !dates[0] || !dates[1]) {
      setForm((prev) => ({
        ...prev,
        startTime: '',
        endTime: '',
        dateStart: null,
        dateEnd: null,
      }));
      return;
    }

    const startDate = dates[0].startOf('month');
    const endDate = dates[1].endOf('month');

    setForm((prev) => ({
      ...prev,
      startTime: startDate.format('YYYY-MM-DD'),
      endTime: endDate.format('YYYY-MM-DD'),
      dateStart: startDate,
      dateEnd: endDate,
    }));
  };

  const getStudentRetaketation = useCallback((params) => {
    setLoading(true);
    return CourseScheduleRegistationServices.getCourseRegistration(params)
      .then((res) => {
        setListCourseRegistration({
          ...res?.data,
          items: res?.data.items.map((item) => ({
            ...item,
          })),
        });
      })
      .catch((err) => toast.error(err.message || NO_INTERNET))
      .finally(() => setLoading(false));
  }, []);

  const handleSearchData = () => {
    setForm({
      ...form,
      page: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE,
      type: 'RETAKE',
    });

    const now = dayjs();
    getStudentRetaketation(
      clearAllFields({
        ...form,
        page: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        startTime: form.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
        endTime: form.endTime || '',
        type: 'RETAKE',
      }),
    );
  };

  const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  function htmlToFormattedText(html, maxLength = 14) {
    return html?.replace(/<p>(.*?)<\/p>/g, (_, content) => {
      // giữ nguyên dòng <p><br></p>
      if (content.trim() === '<br>') return '<p><br></p>';

      let text = content.replace(/&nbsp;/g, ' ').trimStart();

      // cắt 14 ký tự
      text = text.length > 14 ? `${text.slice(0, maxLength)}...` : text;

      return `<p>${text}</p>`;
    });
  }

  const buildExportParams = (baseForm) => {
    const now = dayjs();
    const body = clearAllFields({
      ...baseForm,
      isAll: 1,
      type: 'RETAKE',
      startTime: baseForm.startTime || now.subtract(1, 'year').format('YYYY-MM-DD'),
    });
    if (body.courseId === 'ALL') delete body.courseId;
    if (body.courseScheduleId === 'ALL') delete body.courseScheduleId;
    return body;
  };

  const handleExportData = async () => {
    setLoading(true);
    try {
      const body = buildExportParams(form);
      const res = await CourseScheduleRegistationServices.getCourseRegistration(body, {
        timeout: 120000,
      });
      const items = Array.isArray(res?.data?.items)
        ? res.data.items
        : Array.isArray(res?.data)
          ? res.data
          : [];

      if (items.length === 0) {
        toast.error('No data to export');
        return;
      }

        const dataExport = items.map((item) => {
          const attendance = {};

          // init 1 → 8
          for (let day = 1; day <= 8; day++) {
            attendance[`受講日(${day}日目)`] = '';
          }

          // map theo day
          item.schedule?.forEach((sc) => {
            if (sc?.day >= 1 && sc?.day <= 8) {
              attendance[`受講日(${sc.day}日目)`] =
                statusOptions.find((st) => st.value === sc.status)?.label || '';
            }
          });

          const firstDay = item.courseSchedules?.schedule?.[0];

          return {
            開催ID: item?.courseSchedules?.eventId || '',
            開催1日目:
              firstDay?.startTime && dayjs(firstDay.startTime).isValid()
                ? `${dayjs(firstDay.startTime).format('YYYY/MM/DD')}`
                : '',
            名前: item.users?.name || '',
            メールアドレス: item.users?.email || '',
            電話番号: item?.users.phone ? `="${item?.users.phone}"` : '',
            領収書宛名:
              item?.receiptRecipient === 'REQUEST'
                ? item?.receiptAddressee || item?.users?.name || ''
                : '',
            申込日:
              item.createdAt && dayjs(item.createdAt).isValid()
                ? `="${dayjs(item.createdAt).format('YYYY/MM/DD')}"`
                : '',
            ...attendance,
            備考: stripHtml(item.notes),
          };
        });

        const headers = [
          '開催ID',
          '開催1日目',
          '名前',
          'メールアドレス',
          '電話番号',
          '領収書宛名',
          '申込日',
          ...Array.from({ length: 8 }, (_, i) => `受講日(${i + 1}日目)`),
          '備考',
        ];

        const ws = XLSX.utils.json_to_sheet(dataExport.length > 0 ? dataExport : [], {
          header: headers,
        });

        ws['!cols'] = [
          { wch: 12 },
          { wch: 15 },
          { wch: 25 },
          { wch: 12 },
          { wch: 12 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 12 },
        ];

        const csv = XLSX.utils.sheet_to_csv(ws, {
          FS: ',',
          RS: '\r\n',
          strip: false,
        });

        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csv], {
          type: 'text/csv;charset=utf-8;',
        });

        saveAs(blob, 'newStudentRetake.csv');
      toast.success('ダウンロードしました');
    } catch (err) {
      toast.error(typeof err === 'string' ? err : err?.message || NO_INTERNET);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StudentRetaketationWrapper>
      <Spin spinning={loading}>
        <div className="mb-4 flex h-10 flex-col items-end justify-end gap-4 xl:h-24 2xl:h-24">
          <div className="flex h-10 w-max items-end justify-end gap-4 xl:flex-col xl:gap-4 2xl:flex-col">
            <div className="hidden xl:!flex xl:h-10 xl:w-full xl:justify-end 2xl:!flex 2xl:h-10 2xl:w-full 2xl:justify-end">
              <Input
                placeholder="名前、メールアドレス"
                $autoTrim={true}
                width={280}
                className="hidden xl:flex xl:h-10 xl:!max-w-[1000px] xl:justify-end 2xl:flex 2xl:h-10 2xl:max-w-[1000px] 2xl:justify-end"
                classNameInput="xl:w-full"
                isPopup={false}
                height={40}
                value={form.search}
                onChange={(e) => handleChangeData({ label: 'search', value: e })}
              />
            </div>
            <div className="flex h-10 w-max items-center justify-end gap-4">
              <Input
                placeholder="名前、メールアドレス"
                $autoTrim={true}
                width={280}
                className="xl:!hidden 2xl:!hidden"
                classNameInput="2xl:!max-w-[335px]"
                isPopup={false}
                height={40}
                value={form.search}
                onChange={(e) => handleChangeData({ label: 'search', value: e })}
              />
              <Select
                label="コース:"
                options={[
                  {
                    value: 'ALL',
                    label: '全て',
                  },
                  ...course,
                ]}
                value={form.courseId || 'ALL'}
                isPopup={false}
                $width={180}
                $height={40}
                classNameSelect="xl:w-[150px] 2xl:w-[150px]"
                className="xl:w-[220px] 2xl:w-[220px]"
                onChange={(e) => handleChangeData({ label: 'courseId', value: e.value })}
                iconDown={images.icon.src}
              />
              <Select
                label="開催ID:"
                options={[
                  {
                    value: 'ALL',
                    label: '全て',
                  },
                  ...(courseId || []),
                ]}
                value={form.courseScheduleId || 'ALL'}
                isPopup={false}
                $width={180}
                classNameSelect="xl:w-[150px] 2xl:w-[150px]"
                className="xl:w-[220px] 2xl:w-[220px]"
                $height={40}
                onChange={(e) =>
                  handleChangeData({
                    label: 'courseScheduleId',
                    value: e.value,
                  })
                }
                iconDown={images.icon.src}
              />

              <div className="2xl:!w-[300px]xl:!w-[300px] flex items-center justify-end gap-4">
                <span className="text-nowrap font-normal">日程 :</span>
                <div className="w-[200px]">
                  <ChooseMonthDate
                    value={form.dateStart && form.dateEnd ? [form.dateStart, form.dateEnd] : null}
                    onChange={handleDateChange}
                  />
                </div>
              </div>
              <Button btnType="outline" width={84} height={40} onClick={handleSearchData}>
                <p style={{ letterSpacing: '0', fontSize: 14 }}>検索</p>
              </Button>
            </div>
          </div>
        </div>

        <Divider className="mb-4" />

        <div className="mb-4 flex items-center justify-between">
          <Button btnType="primary" width={120} height={40} onClick={() => setAddMember(true)}>
            <p style={{ letterSpacing: '0', fontSize: 14 }}>追加</p>
          </Button>
          <Button width={160} height={40} btnType="back" onClick={handleExportData}>
            <p
              style={{
                letterSpacing: '0',
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <images.download.src width={20} height={20} />
              ダウンロード
            </p>
          </Button>
        </div>

        <CustomTable
          columns={columns}
          dataSource={listCourseRegistration?.items || []}
          scrollX={1200}
          sticky={{ offsetHeader: 0 }}
          rowKey="_id"
        />

        <div className="mt-6 flex w-full items-center justify-end">
          <Pagination
            total={listCourseRegistration?.count ?? 0}
            pageSize={form.pageSize || DEFAULT_PAGE_SIZE}
            page={form.page || DEFAULT_PAGE_NUMBER}
            onChangePage={handleChangePage}
          />
        </div>

        <NotePopup
          isOpen={!!noteId}
          onCancel={() => {
            setNoteId(null);
          }}
          noteId={noteId}
          onSuccess={() => {
            setNoteId(null);
            getStudentRetaketation(
              clearAllFields({
                ...form,
                type: 'RETAKE',
                timezone: TIME_ZONE,
              }),
            );
          }}
        />

        <InfoUserPopup
          isOpen={!!infoId}
          onCancel={() => {
            setInfoId(null);
          }}
          infoId={infoId}
        />

        <PopupConfirm
          isOpen={!!changeStatusConfirm.courseId}
          onCancel={() =>
            setChangeStatusConfirm({
              courseId: null,
              status: null,
            })
          }
          message={changeStatusConfirm?.message}
          courseId={changeStatusConfirm?.courseId}
          day={changeStatusConfirm?.day}
          status={changeStatusConfirm?.status}
          onSuccess={() =>
            getStudentRetaketation(
              clearAllFields({
                ...form,
                timezone: TIME_ZONE,
                type: 'RETAKE',
              }),
            )
          }
        />

        <AddMemberPopup
          isOpen={!!addMember}
          onCancel={() => {
            setAddMember(null);
          }}
          onSuccess={() => {
            const now = dayjs();
            setForm({
              ...form,
              page: DEFAULT_PAGE_NUMBER,
              pageSize: DEFAULT_PAGE_SIZE,
            });
            getStudentRetaketation(
              clearAllFields({
                page: DEFAULT_PAGE_NUMBER,
                pageSize: DEFAULT_PAGE_SIZE,
                type: 'RETAKE',
                startTime: now.subtract(1, 'year').format('YYYY-MM-DD'),
              }),
            );
          }}
        />
      </Spin>
    </StudentRetaketationWrapper>
  );
};

export default RetakeStudentManagement;
